module.exports = __webpack_public_path__ + "static/img/left-bottom-row-5.266c04c6.webp";